import { API_BASE_URL, REQUEST_CONFIG } from '@/config'

export default class Util {
    static add() {
        console.log("add");
    }

    // HTTP请求方法
    static async request(url: string, options: RequestInit = {}) {
        const config = {
            ...REQUEST_CONFIG,
            ...options
        }

        // 如果是 FormData，不设置 Content-Type，让浏览器自动处理
        if (!(options.body instanceof FormData)) {
            config.headers = {
                'Content-Type': 'application/json',
                ...options.headers
            }
        } else {
            // 对于 FormData，只保留其他 headers，不设置 Content-Type
            config.headers = {
                ...options.headers
            }
        }

        try {
            const response = await fetch(`${API_BASE_URL}${url}`, config)
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }
            
            return await response.json()
        } catch (error) {
            console.error('Request failed:', error)
            throw error
        }
    }

    // 登录方法
    static async login(username: string, password: string) {
        const formData = new FormData()
        formData.append('username', username)
        formData.append('password', password)
        
        return this.request('/api-palm/login', {
            method: 'POST',
            body: formData,
            headers: {
                // 移除 Content-Type，让浏览器自动设置 multipart/form-data
            }
        })
    }

    // 获取首页内容
    static async getIndexContent(type: string) {
        const formData = new FormData()
        formData.append('type', type)
        formData.append('page_type', "2")
        return this.request('/api-palm/getContent', {
            method: 'POST',
            body: formData
        })
    }

    // 保存首页内容
    static async saveIndexContent(contentData: any) {
        contentData.page_type = "2"
        return this.request('/content/index', {
            method: 'POST',
            body: JSON.stringify(contentData)
        })
    }

    // 保存内容
    static async saveContent(body: any) {
        const formData = new FormData()
        
        // 将body对象的所有属性添加到FormData中
        for (const key in body) {
            formData.append(key, body[key])
        }
        formData.append('page_type', "2")
        return this.request('/api-palm/saveContent', {
            method: 'POST',
            body: formData
        })
    }

    // 存储token
    static setToken(token: string) {
        localStorage.setItem('admin_token', token)
    }

    // 获取token
    static getToken(): string | null {
        return localStorage.getItem('admin_token')
    }

    // 清除token
    static clearToken() {
        localStorage.removeItem('admin_token')
    }

    // 检查是否已登录
    static isLoggedIn(): boolean {
        return !!this.getToken()
    }
}